/**
 * @format
 */

import React, { useEffect, useState } from 'react';
import {
  ActivityIndicator,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
} from 'react-native';
import { Image } from 'react-native-elements';

import { AccountProps } from '../../lib/account';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { selectPropertyManager } from '../../store/propertyManagerSlice';

export type Props = {
  containerStyle?: StyleProp<ViewStyle>;
} & AccountProps;

const DEFAULT_LANDING_IMAGE_URL =
  '../../assets/notificationbg/notificationbg.png';

const CondoLandingHero: React.FC<Props> = (props) => {
  const { propertyName, unitId, username, corpName } = props;
  const [landingUrl, setLandingUrl] = useState(DEFAULT_LANDING_IMAGE_URL);

  const { data: propertyManagerData, isSucess: isPropertyManagerSuccess } =
    useSelector((state: RootState) => selectPropertyManager(state));

  useEffect(() => {
    if (
      isPropertyManagerSuccess &&
      propertyManagerData?.landing_screen_image?.url
    ) {
      setLandingUrl(propertyManagerData?.landing_screen_image?.url);
    } else {
      setLandingUrl(DEFAULT_LANDING_IMAGE_URL);
    }
  }, [isPropertyManagerSuccess, propertyManagerData]);

  return (
    <View style={[styles.container, props.containerStyle]}>
      <Image
        fadeDuration={0}
        transition={false}
        source={
          isPropertyManagerSuccess &&
          propertyManagerData?.landing_screen_image?.url
            ? {
                uri: landingUrl,
              }
            : require(DEFAULT_LANDING_IMAGE_URL)
        }
        style={styles.backgroundImage}
        resizeMode="cover"
        PlaceholderContent={<ActivityIndicator />}
      />
      {!!propertyName && (
        <View style={[styles.textUnderlay]}>
          <Text style={[styles.overlayText, styles.small]}>{propertyName}</Text>
        </View>
      )}
      <View style={[styles.textUnderlayBottom]}>
        {!!unitId && (
          <Text style={[styles.overlayText, styles.unitText]}>
            UNIT {unitId}
          </Text>
        )}
        {!!username && (
          <Text style={[styles.overlayText, styles.nameText]}>
            Welcome {username}!
          </Text>
        )}
      </View>
      <View style={styles.textContainer} />
    </View>
  );
};

const height = 240;
const width = '100%';
const underlayTextColor = '#00000060';

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#efefef',
    width: width,
    height: height,
  },
  underlay: {
    position: 'absolute',
    backgroundColor: '#000000',
    width: width,
    height: height,
    opacity: 0.5,
  },
  backgroundImage: {
    width: '100%',
    height: 240,
  },
  textContainer: {
    position: 'absolute',
    bottom: 28,
    marginHorizontal: 16,
  },
  overlayText: {
    color: 'white',
    fontSize: 20,
  },
  large: {
    fontSize: 34,
  },
  small: {
    fontSize: 13,
    fontWeight: '300',
  },
  unitText: {
    fontSize: 14,
  },
  nameText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  textUnderlay: {
    backgroundColor: underlayTextColor,
    position: 'absolute',
    top: 20,
    paddingVertical: 5,
    paddingStart: 20,
    paddingEnd: 5,
  },
  textUnderlayBottom: {
    backgroundColor: underlayTextColor,
    position: 'absolute',
    bottom: 20,
    paddingVertical: 0,
    paddingStart: 20,
    paddingEnd: 5,
  },
});

export default CondoLandingHero;
